import {
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@material-ui/core";
import DialogDragable from "components/DialogDragable";
import moment from "moment";
import mainClasses from "pages/agent-chat-ticket/AgentChatTicket.module.css";
import TicketAllHistoryDialog from "pages/agent-chat-ticket/ticket/TicketAllHistoryDialog";
import TicketHistoryDetail from "pages/agent-dashboard/TicketHistoryDetail";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getListChatTicketHistoryByUsername } from "redux/ringme-ott-sdk";

import classes from "../AgentChatTicket.module.css";

const TicketHistory = () => {
  const dispatch = useDispatch();

  const threadInfo = useSelector((state) => state.ringmeOttSdk.threadInfo);
  const ringmeOttSdk = useSelector((state) => state.ringmeOttSdk.ringmeOttSdk);
  const listChatTicketHistory = useSelector(
    (state) => state.ringmeOttSdk.listChatTicketHistory
  );
  const loadingListChatTicketHistory = useSelector(
    (state) => state.ringmeOttSdk.loadingListChatTicketHistory
  );
  const [openDialogChatHistory, setOpenDialogChatHistory] = useState(false);

  const threadPhoneNumber = threadInfo?.sender?.phoneNumber;

  useEffect(() => {
    dispatch(getListChatTicketHistoryByUsername(threadPhoneNumber));
  }, [threadPhoneNumber, dispatch]);

  return (
    <div style={{ color: "black" }}>
      <div style={{ marginBottom: 10 }}>
        <span style={{ fontSize: 20, color: "#fcb71e" }}>
          <i className="fas fa-history"></i> Lịch sử tương tác
        </span>
      </div>
      <Tooltip title="Xem chi tiết">
        <span
          className={classes.customerHistory_title}
          onClick={() => setOpenDialogChatHistory(true)}>
          Toàn bộ lịch sử cuộc chat{" "}
          <i
            id="customer-history-icon"
            className={`fas fa-comments ${classes.allChatHistory_icon}`}></i>
        </span>
      </Tooltip>
      <Table style={{ marginTop: 10 }}>
        <TableHead>
          <TableRow>
            <TableCell
              className={mainClasses.tableCell}
              align="center"
              style={{ minWidth: 100 }}>
              Thời gian
            </TableCell>
            <TableCell className={mainClasses.tableCell} align="center">
              Nguồn
            </TableCell>
            <TableCell className={mainClasses.tableCell}>Tên kênh</TableCell>
            <TableCell
              className={mainClasses.tableCell}
              style={{ minWidth: 200 }}>
              Yêu cầu
            </TableCell>
            <TableCell
              className={mainClasses.tableCell}
              style={{ minWidth: 130 }}>
              Mã giao dịch
            </TableCell>
            <TableCell
              className={mainClasses.tableCell}
              style={{ minWidth: 75 }}
              align="center">
              Chi tiết ticket
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loadingListChatTicketHistory && (
            <TableRow style={{ border: "none" }}>
              <TableCell
                colSpan={1000}
                style={{ border: "none", paddingTop: 25, paddingBottom: 25 }}
                align="center">
                <CircularProgress size={30} />
              </TableCell>
            </TableRow>
          )}
          {!loadingListChatTicketHistory && (
            <>
              {listChatTicketHistory?.length > 0 ? (
                listChatTicketHistory.map((item, index) => (
                  <HistoryRow
                    key={item.id}
                    index={index + 1}
                    row={item}
                    ringmeOttSdk={ringmeOttSdk}
                  />
                ))
              ) : (
                <TableRow style={{ border: "none" }}>
                  <TableCell
                    colSpan={1000}
                    style={{
                      border: "none",
                      paddingTop: 35,
                      paddingBottom: 25,
                    }}
                    align="center">
                    <i
                      className="fal fa-frown"
                      style={{ fontSize: 35, color: "#ccc" }}></i>

                    <p>
                      Rất tiếc, chúng tôi hiện tại không tìm thấy bản ghi nào
                    </p>
                  </TableCell>
                </TableRow>
              )}
            </>
          )}
        </TableBody>
      </Table>
      {openDialogChatHistory && (
        <TicketAllHistoryDialog
          open={openDialogChatHistory}
          onClose={() => setOpenDialogChatHistory(false)}
        />
      )}
    </div>
  );
};

const HistoryRow = ({ row, ringmeOttSdk }) => {
  const [openDetailTicket, setOpenDetailTicket] = useState(false);

  const handleOpenDetailTicket = () => {
    setOpenDetailTicket(true);
  };

  const handleCloseDetailTicket = () => {
    setOpenDetailTicket(false);
  };

  return (
    <>
      <TableRow>
        <TableCell className={mainClasses.tableCell} align="center">
          {!!row.createdAt && (
            <>
              <div>{moment(row.createdAt).format("YYYY-MM-DD")}</div>
              <div>{moment(row.createdAt).format("HH:mm:ss")}</div>
            </>
          )}
        </TableCell>
        <TableCell className={mainClasses.tableCell} align="center">
          {row.source === "ott" ? "chat" : "call"}
        </TableCell>
        <TableCell className={mainClasses.tableCell}>
          {row.source === "ott" ? row.channel : row.sourceName}
        </TableCell>
        <TableCell className={mainClasses.tableCell}>
          {row.ticketType?.name || ""}
        </TableCell>
        <TableCell className={mainClasses.tableCell}>
          {row.attributes?.packageCode || ""}
        </TableCell>
        <TableCell align="center">
          <i
            className={`fas fa-eye ${classes.tableTicketHistory_icon}`}
            onClick={handleOpenDetailTicket}></i>
        </TableCell>
      </TableRow>

      <DialogDragable
        open={openDetailTicket}
        onClose={handleCloseDetailTicket}
        title={
          <span>
            Xem thông tin ticket{" "}
            <span style={{ fontSize: 20, color: "red" }}>
              {row?.attributes?.packageCode || ""}
            </span>
          </span>
        }>
        <TicketHistoryDetail ticketData={row} type="chat" />
      </DialogDragable>
    </>
  );
};

export default TicketHistory;
